/**
 * An abstract GUI control.
 *  id - control identifier, will be used as HTML element id 
 */
export default function GUIControl(id)
{
    this.id = id;

    this.updateLocked = false;
}

/*
 * Context object if needed
 */

GUIControl.prototype.context = null;

/**
 * Returns the control id (HTML element id).
 */
GUIControl.prototype.getId = function()
{
    return this.id;
}


/**
 * Returns the HTML that renders the control.
 * Must be overridden in a subclass.
 */
GUIControl.prototype.getHTML = function()
{
    return "";
}


/**
 * Outputs the control's HTML to the document.
 */
GUIControl.prototype.render = function()
{
    document.write(this.getHTML());
}

/**
 * Renders the control to the specified container.
 */
GUIControl.prototype.renderTo = function( container )
{
    container.innerHTML = this.getHTML();
};

/**
 * Updates the contents of control, if update is not locked.
 */
GUIControl.prototype.updateContents = function()
{
    if (!this.updateLocked)
    {
        var elem = document.getElementById(this.getContentsContainerId());
        if (elem)
        {
            elem.innerHTML = this.getContentsHTML();
        }
    }
}


/**
 * Returns the HTML for the changeable part of the control. This method is called from the updateContents() method
 * and must be overridden in subclasses.
 */
GUIControl.prototype.getContentsHTML = function()
{
    return "";
}


/**
 * Returns the id of the element which innerHTML contains the changeable part of the control.
 * Used in updateContents() method.
 * This method must be queried in subclasses when generating HTML for the static parts of controls. 
 */
GUIControl.prototype.getContentsContainerId = function()
{
    return this.id + ".contentsContainer";
}


/**
 * Locks update, so that updateContents() will have no effect.
 */
GUIControl.prototype.lockUpdate = function()
{
    this.updateLocked = true;
}


/**
 * Unlocks update and immediately updates contents.
 */
GUIControl.prototype.unlockUpdate = function()
{
    this.updateLocked = false;
    this.updateContents();
}



// WEBPACK FOOTER //
// ./web/js/controls/gui_control.js